import { motion } from "framer-motion";

const schools = [
    { code: "ZSGI", name: "School of Global Impact", desc: "Diplomacy, human rights, public policy, SDGs, global affairs.", accent: "gold", primary: true },
    { code: "ZGP", name: "Global Pathways", desc: "International pathways, university partnerships, student mobility." },
    { code: "ZSLX", name: "Leadership & Excellence", desc: "Leadership, personal excellence, communication, entrepreneurship." },
    { code: "ZSAT", name: "AI & Technology", desc: "AI, data, digital transformation, future technologies." },
    { code: "ZSSC", name: "Sustainability & Climate", desc: "Sustainability, ESG, climate action, circular economy." },
    { code: "ZGC", name: "Global Conferences", desc: "Summits, forums, youth events, research dialogues." },
];

export default function EcosystemGrid() {
    return (
        <section data-testid="ecosystem-section" className="section-ivory py-24 md:py-40">
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24">
                <div className="grid md:grid-cols-12 gap-10 mb-16 md:mb-24">
                    <div className="md:col-span-4">
                        <div className="label-mono">— THE Z ED ECOSYSTEM</div>
                    </div>
                    <div className="md:col-span-8">
                        <h2 className="serif-display text-4xl md:text-6xl lg:text-7xl text-[var(--navy)]">
                            One institution. <span className="serif-italic">Six schools.</span> A single purpose.
                        </h2>
                        <p className="mt-6 text-lg text-[var(--navy)]/70 max-w-2xl">
                            ZSGI is the flagship of Z Edustation — surrounded by sister schools that expand the mission across pathways, leadership, technology, sustainability and dialogue.
                        </p>
                    </div>
                </div>

                <div className="grid md:grid-cols-3 border-t border-l border-[rgba(11,30,63,0.15)]">
                    {schools.map((s, i) => (
                        <motion.div
                            key={s.code}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
                            className={`p-8 md:p-10 border-r border-b border-[rgba(11,30,63,0.15)] transition-colors duration-500 group ${
                                s.primary ? "bg-[var(--navy)] text-[var(--ivory)]" : "bg-transparent hover:bg-[var(--navy)] hover:text-[var(--ivory)]"
                            }`}
                            data-testid={`ecosystem-${s.code}`}
                        >
                            <div className={`label-mono ${s.primary ? "text-[var(--gold)]" : "text-[color:#8F6F26] group-hover:text-[var(--gold)]"}`}>
                                / {s.code}
                            </div>
                            <h3 className="serif-display text-3xl md:text-4xl mt-4 leading-tight">{s.name}</h3>
                            <p className={`mt-4 text-base leading-relaxed ${s.primary ? "text-[var(--ivory)]/80" : "text-[var(--navy)]/70 group-hover:text-[var(--ivory)]/80"}`}>
                                {s.desc}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
